import React, {useCallback, useEffect, useState} from 'react';
import MuiDrawer from '@mui/material/Drawer';
import {Close} from '@mui/icons-material'
import styled from 'styled-components';
import StepOneTask from './StepOneTask';
import StepTwoTask from './StepTwoTask';
import StepThreeTask from './StepThreeTask';

const StyledDrawer = styled(MuiDrawer).withConfig({ shouldForwardProp: (prop) => prop !== 'open' })<{open: boolean;}>`
  height: 100%;
  width: ${p => p.open ? 'auto' : `0`};
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1200;

  .MuiDrawer-paper {
    position: relative;
    transition: width 0.5s ease;
  }
  ${p => p.open && `
    &::before {
      content: '';
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(2px);
      z-index: -1;
    }
  `}
`;

export type QuestionData = {
    question: string;
    answer: string;
    isLocked: boolean;
};
type StepTextType = {
    [key: number]: string;
};
export type StepData = {
    step1: {
        name: string;
        taskDescription: string;
    };
    step2: {
        video: string;
        instructions: string;
        resources: string;
        file_name: string | undefined;
        file_extension: string | undefined;
    };
    step3: {
        questions: QuestionData[];
    };
};

const ChapterTaskDrawer = ({activeDrawer, setActiveDrawer, task, open, close, onSaveTask, contentIndex }: {setActiveDrawer: (data: any) => void, activeDrawer: string, contentIndex: any, selectedChapterId: string, task?: any, open: boolean, close: (e?: string) => void, onSaveTask: (data: any) => void, }) => {
    const [value, setValue] = useState({
        step1: {
            name: '',
            taskDescription: ''
        },
        step2: {
            video: '',
            instructions: '',
            resources: '',
            file_name: '',
            file_extension: ''
        },
        step3: {
            questions: [{
                question: '',
                answer: '',
                isLocked: false
            }]
        }
    });
    const [currentStep, setCurrentStep] = useState(1);
    // eslint-disable-next-line
    const [invalid, setInvalid] = useState(true);
    
    useEffect(() => {
        if (activeDrawer === 'task' && contentIndex !== -1 && task) {
            setValue({
                step1: {
                    name: task.exercise_name || '',
                    taskDescription: task.description || ''
                },
                step2: {
                    video: task.video,
                    instructions: task.instructions || '',
                    resources: task.file || '',
                    file_name: task.file_name || '',
                    file_extension: task.file_extension || ''
                },
                step3: {
                    questions: task.questions
                }
            });
        } else {
            return
        }
    }, [activeDrawer, contentIndex, task,]);

    const handleClose = (value?:any) => {
        close(value);
        setActiveDrawer('');
    };
    const handleStepChange = (stepData: any) => {
        setValue(prevValue => ({
            ...prevValue,
            ...stepData
        }));
    };
    const validateData = useCallback((data: StepData) => {
        switch (currentStep) {
            case 1:
                setInvalid(!data.step1.name || !data.step1.taskDescription);
                break;
            case 2:
                setInvalid(!data.step2.instructions || !data.step2.resources || !data.step2.video);
                break;
            case 3:
                setInvalid(false)
                break;
            default:
                setInvalid(true);
        }
    }, [currentStep]);
    useEffect(() => {
        validateData(value);
    }, [validateData, value, currentStep]);

    const nextStep = () => {
        setCurrentStep(currentStep + 1);
    };
    
    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return <StepOneTask data={value.step1} onDataChange={handleStepChange} nextStep={nextStep} />;
            case 2:
                return <StepTwoTask data={value.step2} onDataChange={handleStepChange} nextStep={nextStep} />;
            case 3:
                return <StepThreeTask data={value} onDataChange={handleStepChange} handleSave={onSaveTask} close={handleClose} />;
            default:
                return null;
        }
    };


    const getStepIndicatorClass = (stepNumber: number) => {
        return currentStep >= stepNumber ? "step-indicator-item active" : "step-indicator-item";
    };
    const stepText: StepTextType = {
        1: "Общая информация",
        2: "Инструкция",
        3: "Вопросы и ответы"
    };
    return(
        <StyledDrawer variant="permanent"
                      anchor="right"
                      open={open}
        >
            <div className="chapter-drawer-close" onClick={() => handleClose()}><Close/></div>
            <div className="chapter-drawer-content">
                <div>
                    <div className="constructor-content-title-task">
                        Добавить задание
                    </div>
                    <div className="constructor-content-subtitle">
                        {stepText[currentStep]}
                    </div>
                    <div className="step-indicator">
                        <div className={getStepIndicatorClass(1)}></div>
                        <div className={getStepIndicatorClass(2)}></div>
                        <div className={getStepIndicatorClass(3)}></div>
                    </div>
                    <div className="lecture-type-select-wrapper">
                        {renderStepContent()}
                    </div>
                </div>
            </div>
        </StyledDrawer>
    );
}
export default ChapterTaskDrawer;
